import CollectionESSearchWildcardPane from '@components/collection/Collection/CollectionESSearchWildcardPane'
import CollectionRunsheetsView from '@components/collection/Collection/CollectionRunsheetsView'
import { Mosaic } from 'react-mosaic-component'

/**
 * 
 * @param {CollectionViewModel} vm
 * @returns {JSX.Element}
 * @constructor
 */
const CollectionWildcardSearchView = ({
    vm,
}) => {
    
    return (
        
        <Mosaic
            className="parse-mosaic"
            renderTile={id => ({
                docs: <CollectionESSearchWildcardPane vm={vm} />,
                runsheets: vm.selectedRunsheet && <CollectionRunsheetsView vm={vm} />,
            })[id]}
            resize={!vm.selectedRunsheet ? 'DISABLED' : { minimumPaneSizePercentage: 1 }}
            initialValue={{
                direction: 'column',
                first: 'docs',
                second: 'runsheets',
                splitPercentage: vm.selectedRunsheet ? 50 : 100,
            }} />
        
    )
    
}

export default CollectionWildcardSearchView
